export const privateheader = 'Λίστα Χειρουργείων Ιδιωτικής Δομής';
